import {ReactNode} from 'react';
import {useScreenResize} from 'hooks';
import {useKioskoStore} from 'context/kiosko/useKioskoStore';
import {device} from 'styled/device';
import {Navbar as MobileNavbar} from './Components/Navbar';
import {Footer} from './Components/Footer';
import {PageWrapper, Wrapper} from './styled';

type PageUniversalLinkProps = {
  children: ReactNode;
  className?: string;
};

function PageUniversalLink({children, className}: PageUniversalLinkProps) {
  const {isMatch: isMobile} = useScreenResize(device.tablet);
  const isKiosko = useKioskoStore(state => state.connection.isConnected);
  const showMobileNavbar = isMobile;

  return (
    <PageWrapper>
      {showMobileNavbar && <MobileNavbar />}
      {/* TODO refactor this whole implementation implementing this component on a higher level */}
      <Wrapper className={'page_content ' + className}>{children}</Wrapper>
      {!isKiosko && <Footer />}
    </PageWrapper>
  );
}

export {PageUniversalLink};
